<template>
  <DataTable :value="resultItems" :filters="filters" responsiveLayout="stack">
    <Column header="ID" field="id" :sortable="true" style="max-width: 80px">
      <template #body="props">
        <a :href="`/login?accountId=${props.data.id}`">{{ props.data.id }}</a>
      </template>
    </Column>
    <Column
      header="Nome"
      field="name"
      filterMatchMode="contains"
      :sortable="true"
      style="min-width: 150px"
    >
      <template #filter>
        <InputText
          type="text"
          v-model="filters.name"
          class="p-column-filter"
          placeholder="Pesquisar Nome"
        />
      </template>
    </Column>

    <Column
      header="Contatos"
      field="contacts"
      style="min-width: 250px"
      filterMatchMode="contains"
    >
      <template #body="{ data: { phone, email } }">
        <span v-if="phone || email">
          <span v-if="phone && phone.length === 10">
            Telefone: {{ $formatPhone(phone) }}<br />
          </span>
          <span v-if="phone && phone.length === 11">
            Celular: {{ $formatCellPhone(phone) }}<br />
          </span>
          <span v-if="email"> Email: {{ email }} <br /> </span>
        </span>
        <span v-else> - </span>
      </template>
      <template #filter>
        <InputText
          type="text"
          v-model="filters.contacts"
          class="p-column-filter"
          placeholder="Pesquisar Contatos"
        />
      </template>
    </Column>

    <Column header="Status" field="statusName" :sortable="true">
      <template #body="{ data }">
        <AccountStatus :id="data?.status?.id" :name="data?.status?.name" />
      </template>
      <template #filter>
        <InputText
          type="text"
          v-model="filters.statusName"
          class="p-column-filter"
          placeholder="Pesquisar Status"
        />
      </template>
    </Column>

    <Column header="Plano" field="planName" :sortable="true">
      <template #body="{ data }">
        <AccountPlan :id="data?.plan?.id" :name="data?.plan?.name" />
      </template>
      <template #filter>
        <InputText
          type="text"
          v-model="filters.planName"
          class="p-column-filter"
          placeholder="Pesquisar Plano"
        />
      </template>
    </Column>

    <Column
      header="Valor Mensal"
      field="billValue"
      :sortable="true"
      filterMatchMode="gte"
    >
      <template #body="{ data }">
        <span v-if="data.billValue">
          {{ $toCurrency(data.billValue) }}
        </span>
        <span v-else> - </span>
      </template>
      <template #filter>
        <InputText
          type="text"
          v-model="filters.billValue"
          class="p-column-filter"
          placeholder="Pesquisar Valor"
        />
      </template>
    </Column>

    <Column
      header="Data de Vencimento"
      field="dueDate"
      :sortable="true"
      filterMatchMode="contains"
    >
      <template #body="{ data }">
        <span v-if="data.dueDateFormatted">
          {{ data.dueDateFormatted }}
        </span>
        <span v-else> - </span>
      </template>
      <template #filter>
        <InputText
          type="text"
          v-model="filters.dueDate"
          class="p-column-filter"
          placeholder="Pesquisar Data"
        />
      </template>
    </Column>

    <Column header="Ações" headerStyle="width: 100px">
      <template #body="{ data: { id } }">
        <AppRowActions
          :editLink="{ name: 'account.edit', params: { id } }"
          @delete="showDeleteConfirm(results, id, 'name')"
        ></AppRowActions>
      </template>
    </Column>
  </DataTable>

  <Paginator
    :rows="query.pageSize"
    :totalRecords="pagination.total"
    @page="changeListPage({ page: $event.page + 1 })"
  ></Paginator>

  <router-link :to="{ name: 'account.create' }" style="text-decoration: none">
    <AppFloatButton icon="pi pi-plus" />
  </router-link>

  <AppModalDelete
    type="Conta"
    :visible="deleteConfirm.visible"
    :item="deleteConfirm.item"
    @confirm="onDelete()"
    @cancel="hideDeleteConfirm()"
  ></AppModalDelete>
</template>

<script>
import useDeleteConfirm from '../../lib/useDeleteConfirm';
import useApiList from '../../lib/useApiList';
import { AccountApi } from '../../services/api/admin';
import AccountStatus from './components/AccountStatus.vue';
import AccountPlan from './components/AccountPlan.vue';

export default {
  name: 'AccountList',
  components: {
    AccountStatus,
    AccountPlan,
  },
  setup() {
    return {
      ...useApiList(AccountApi),
      ...useDeleteConfirm(),
    };
  },
  data() {
    return {
      filters: {},
    };
  },
  async created() {
    await this.fetchList();
  },
  computed: {
    resultItems() {
      return this.results.map((result) => {
        return {
          ...result,
          statusName: result?.status?.name || '',
          planName: result?.plan?.name || '',
          billValue: result.billValue || result?.plan?.billValue || 0,
          contacts: `${result.email || ''} ${result.phone || ''}`,
          dueDateFormatted: result.dueDate
            ? this.$dayjs(result.dueDate).format('DD/MM/YYYY')
            : null,
        };
      });
    },
  },
  methods: {
    onDelete() {
      this.deleteListItem(this.deleteConfirm.id);
      this.hideDeleteConfirm();
    },
  },
};
</script>

<style scoped>
.p-column-filter {
  width: 100%;
}
</style>
